import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  reistrationForm: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {  window.scroll({top:0,left:0,behavior:"smooth"});
    this.reistrationForm = this.formBuilder.group({
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required],
      phone: ['', Validators.required]
    });
  }
  register() {
    // routerLink="/successfully-register"
    this.reistrationForm.markAllAsTouched();
  }
}
